import { useCallback } from 'react';

import { AnalyticsEvent, useAnalytics } from '@bonusly/analytics';

export const useBonusBoxAnalytics = () => {
	const { track, trackEvent } = useAnalytics();

	const trackBonusStart = useCallback(() => {
		track(AnalyticsEvent.GiveBox.BonusStart);
	}, [track]);

	const trackSubmitFailure = useCallback(
		(eventProps?: any) => {
			track(AnalyticsEvent.GiveBox.BonusSubmit, {
				...eventProps,
				result: 'failure',
			});
		},
		[track]
	);

	const trackSubmitSuccess = useCallback(
		(eventProps: any) => {
			track(AnalyticsEvent.GiveBox.BonusSubmit, {
				...eventProps,
				result: 'success',
			});
			trackEvent(AnalyticsEvent.GiveBox.RecognitionGiven, eventProps);
		},
		[track, trackEvent]
	);

	return { trackBonusStart, trackSubmitFailure, trackSubmitSuccess };
};
